import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../components/ParadigmaModal/ParadigmaModal.js";
import api from "../../api";
import apifunctions from "../../api/functions.js";

import { Button } from 'reactstrap';

import ParadigmaAsyncSeeker from "../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import ParadigmaLabeledInput from "../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js"
import LotesTable from './LotesTable.js';
import ModalLoteo from "../Loteos/Modal";

class Modal extends Component {
    constructor(props) {
        super("props",props);
        this.state = {
            id: null,
            Usuario_id:null,
            loteo_id:null,
            TodosLotesDisponibles:true,
            LotesPuedeVender_id:[],
            LoteosPuedeVender_id:[],
            postVariables: ['Usuario_id', 'TodosLotesDisponibles', 'LotesPuedeVender_id', 'LoteosPuedeVender_id'],
            errors: [],
            TodosLotesIds_Loteo:[],
        };

        this.LotesTableRef = React.createRef();
    }

    static propTypes = {
        onSubmit: PropTypes.func,
        id: PropTypes.func,
        action: PropTypes.oneOf(['CREATE', 'EDIT', 'DETAIL', 'DELETE']).isRequired,
    }

    resetForm() {
        this.setState({
            id: null,
            Usuario_id:null,
            loteo_id:null,
            TodosLotesDisponibles:true,
            LotesPuedeVender_id:[],
            LoteosPuedeVender_id:[],
            errors: [],
        });
    }

    getData() {
        const { postVariables } = this.state;
        let data = {};
        postVariables.forEach(x => {
            data[x] = this.state[x];
        });
        return data;
    }

    setData(data) {
        if (data.success) {
            let row = this.props.row();
            this.setState({
                id: data.id,
                Usuario_id:data.Usuario_id?data.Usuario_id : null,
                loteo_id:row.loteo_id ? row.loteo_id : null,
                TodosLotesDisponibles:this.parseBoolean(data.TodosLotesDisponibles),
                LotesPuedeVender_id:data.LotesPuedeVender_id ? data.LotesPuedeVender_id : [],
                LoteosPuedeVender_id:data.LoteosPuedeVender_id ? data.LoteosPuedeVender_id : [],
            })
        }
    }

    setErrors(errors) {
        this.setState({
            errors: errors,
        });
    }

    onChangeField(field, value) {
        this.setState(prevState => {
            let errors = prevState.errors;
            if (errors) errors[field] = null;
            prevState.errors = errors;
            prevState[field] = value;
            return prevState;
        });
    }

    getError(field) {
        let errors = this.state.errors;
        if (errors) return errors[field];
        else return null;
    }

    parseBoolean(value) {
        return value === true || value === 'true' || value === 'True' || value === 1 || value === '1';
    }

    isRestrictingLotes() {
        return !this.parseBoolean(this.state.TodosLotesDisponibles);
    }

    setRestrictingLotes(value) {
        if (this.props.action == "DETAIL") return;
        this.setState(prevState => {
            let errors = prevState.errors;
            if (errors) errors.TodosLotesDisponibles = null;
            return {
                ...prevState,
                TodosLotesDisponibles: !value,
                errors: errors,
            };
        });
    }

    modalVars() {
        const { action } = this.props;
        if (action == "CREATE") {
            return {
                get: false,
                submitType: "POST",
                title: "Nuevo Perfil de Venta para Usuario Vendedor",
                buttonTitle: "Nuevo",
                danger: false,
                buttonIcon: "fa fa-plus fa-lg",
                successMessage: "El Perfil de Venta ha sido creado con éxito.",
                saveButton: true,
                saveButtonLabel: "Guardar",
                buttonClass: "",
                disabled: false,
            };
        } else if (action == "EDIT") {
            return {
                get: true,
                submitType: "PUT",
                title: "Editar Perfil de Venta para Usuario Vendedor",
                buttonTitle: "Editar",
                danger: false,
                buttonIcon: "fa fa-pencil fa-lg",
                successMessage: "El Perfil de Venta ha sido editado con éxito.",
                saveButton: true,
                saveButtonLabel: "Guardar",
                buttonClass: "",
                disabled: false,
                id: this.props.id,
            };
        } else if (action == "DETAIL") {
            return {
                get: true,
                submitType: null,
                title: "Perfil de Vendedor",
                buttonTitle: "Ver",
                danger: false,
                buttonIcon: "fa fa-search fa-lg",
                successMessage: "",
                saveButton: false,
                buttonClass: "",
                disabled: true,
                id: this.props.id,
            };
        } else if (action == "DELETE") {
            return {
                get: true,
                submitType: "DELETE",
                title: "Eliminar Perfil de Venta",
                buttonTitle: "Eliminar",
                danger: true,
                buttonIcon: "fa fa-trash fa-lg",
                successMessage: "El Perfil de Venta ha sido eliminado con éxito.",
                saveButton: true,
                saveButtonLabel: "Eliminar",
                buttonClass: "btn-danger",
                disabled: true,
                id: this.props.id,
            };
        }
    }

    setAllLotes(loteo_id){
         if(loteo_id){
              let callback = ()=>this.LotesTableRef.current && this.LotesTableRef.current.updateTable();
              let callbackFailure = () => {};
              let callbackSuccess = (data) => {
                   let TodosLotesIds_Loteo = this.state.LotesPuedeVender_id ? this.state.LotesPuedeVender_id : [] ;
                   if(data && data.data && data.data.length > 0){
                        data.data.forEach((item, i) => {
                             TodosLotesIds_Loteo.push(item.id);
                        });
                        TodosLotesIds_Loteo = TodosLotesIds_Loteo.filter((item, pos)=> TodosLotesIds_Loteo.indexOf(item) == pos);
                   }
                   this.setState(
                        prevState=>{
                             prevState.LotesPuedeVender_id = TodosLotesIds_Loteo;
                             return prevState;
                        }
                   );
              };
              apifunctions.get(
                   api.loteos.lotes, loteo_id, null,{paginationEnabled:"false"},
                   callbackSuccess, callbackFailure, callbackFailure
              );
              setTimeout(callback, 1500);
         }
    }

    render() {
        let vars = this.modalVars();
        const fieldClassNames = ["ui-field-label-col", "ui-field-control-col"];
        const restringirLotes = this.isRestrictingLotes();
        const {
             Usuario_id,
             LotesPuedeVender_id,loteo_id,
        } = this.state;
        const LotesChanged = (id, added) => {
             this.setState(
                  prevState=>{
                       let LotesPuedeVender_id_filtered = prevState.LotesPuedeVender_id.filter(item=>item!=id);
                       if(added == true){
                            LotesPuedeVender_id_filtered.push(id);
                       }
                       prevState.LotesPuedeVender_id = LotesPuedeVender_id_filtered;
                       return prevState;
                  }
             );
        };
        const onSubmitcallback = (e)=> {
             this.props.refreshTable();
             this.props.onSubmit(e);
        };

        return (
            <ParadigmaModal
                getUrl={(vars.get ? api.vendedores.vendedores : null)}
                submitUrl={(vars.submitType ? api.vendedores.vendedores : null)}
                submitType={vars.submitType}
                id={vars.id}
                className={this.props.action == "DELETE" ? "ui-paradigma-modal" : "ui-paradigma-modal ui-paradigma-modal-wide"}
                onGotData={(data) => this.setData(data)}
                onGotErrors={(errors) => this.setErrors(errors)}
                onSubmit={onSubmitcallback}
                onClose={() => this.resetForm()}
                onPreSubmit={() => this.getData()}

                title={vars.title}

                danger={vars.danger}
                buttonClass={vars.buttonClass}

                successMessage={vars.successMessage}
                missingIdMessage={"Debe seleccionar una fila."}
                saveButtonLabel={vars.saveButtonLabel}
                buttonTitle={vars.buttonTitle}
                buttonIcon={vars.buttonIcon}
                saveButton={vars.saveButton}
                closeButton={true}
            >
            <section className="ui-modal-section">
                 <p className="ui-section-label">Datos del vendedor</p>
                 <div className="ui-form-grid ui-form-grid-align-end">
                      <ParadigmaLabeledInput
                           md={[12, 12]}
                           classNames={fieldClassNames}
                           label={"Usuario"}
                           error = {()=>this.getError('Usuario_id')}
                           inputComponent={
                                <ParadigmaAsyncSeeker
                                    displayField="apellido_nombre"
                                    clearable={false}
                                    url={api.vendedores.usuarios}
                                    parameters={{
                                         paginationEnabled:false,
                                         sort:['apellido_nombre'],
                                         filters:[`create=${this.props.action == "CREATE"}`]
                                    }}
                                    disabled={vars.disabled || this.props.action != "CREATE"}
                                    value={this.state.Usuario_id}
                                    onChange={data => this.onChangeField('Usuario_id',(data)? data.id: null)}
                                />
                           }
                      />
                      {
                           this.props.action != "DELETE" &&
                           <div className="ui-switch-control ui-switch-control-compact">
                                <div className="ui-toggle-row">
                                     <button
                                          type="button"
                                          disabled={vars.disabled || this.props.action == "DETAIL"}
                                          className={"ui-toggle-button" + (restringirLotes ? " is-active" : "")}
                                          aria-pressed={restringirLotes}
                                          onClick={() => this.setRestrictingLotes(!restringirLotes)}
                                     >
                                          <span className="ui-toggle-handle" />
                                     </button>
                                     <button
                                          type="button"
                                          disabled={vars.disabled || this.props.action == "DETAIL"}
                                          className="ui-toggle-label ui-toggle-label-button"
                                          onClick={() => this.setRestrictingLotes(!restringirLotes)}
                                     >
                                          Restringir lotes disponibles
                                     </button>
                                </div>
                           </div>
                      }
                 </div>
            </section>
            {
                 this.props.action != "DELETE" &&
                 <React.Fragment>
                 <section className="ui-modal-section">
                      <p className="ui-section-label">Restricción por loteo</p>
                      <div className="ui-form-grid ui-form-grid-align-end">
                           <ParadigmaLabeledInput
                              md={[12, 12]}
                              classNames={fieldClassNames}
                              label={"Loteo"}
                              error={() => this.getError('loteo_id')}
                              inputComponent={
                                   <div className="ui-async-action-field">
                                        <ParadigmaAsyncSeeker
                                            clearable={false}
                                            url={api.loteos.loteos_select}
                                            parameters={{
                                                paginationEnabled:false,
                                               sort:['nombre']
                                            }}
                                            disabled={!restringirLotes}
                                            value={this.state.loteo_id}
                                            onChange={data => this.onChangeField('loteo_id', (data)? data.id: null)}
                                            DetailComponent={this.state.loteo_id ? (props => <ModalLoteo {...props} action="DETAIL" activeTab={3} />) : null}
                                        />
                                   </div>
                              }
                           />
                           <div className="ui-inline-actions">
                                <Button disabled={this.state.loteo_id == undefined || this.state.loteo_id == null} onClick={()=> this.state.loteo_id && this.setAllLotes(this.state.loteo_id)} color="success">Asignar todos los lotes</Button>
                           </div>
                      </div>
                 </section>
                 <section className="ui-modal-section">
                      <p className="ui-section-label">Lotes disponibles</p>
                      <LotesTable innerRef={this.LotesTableRef} ref={this.LotesTableRef} modernTheme={true} disabled={vars.disabled} Loteo_id={loteo_id ? loteo_id : 0} LotesChanged={LotesChanged} LotesPuedeVender_id={LotesPuedeVender_id} />
                 </section>
                 </React.Fragment>
            }
            </ParadigmaModal>
        );
    }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/views/Vendedores/Modal.js